import app from "flarum/forum/app";
import { override } from "flarum/common/extend";
import Footer from "flarum/forum/components/Footer";
import XgayVisitorCounter from "./components/XgayVisitorCounter";
import initTracker from "./tracker";
app.initializers.add("xgay-visitor-counter", () => {
  initTracker();
  override(Footer.prototype, "view", () => XgayVisitorCounter.component());
});